<div class="login-header">
  <div class="row">
    <div class="col-sm">
      <div class="header">
        <span class="header-client-logo">
          <img [src]="logo" alt="" />
        </span>
      </div>
    </div>
    <div class="language-dropdown w-auto">
      <div class="dropdown">
        <button class="btn btn-icon dropdown-toggle" type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false" (click)="toggleDropdown()">
          <img class="icon-custom" [src]="selectedLanguageIcon" alt="Selected Language Icon" aria-hidden="true" />
          <span class="lang-text">{{ getSelectedLanguageValue() }}</span>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" [class.show]="dropdownOpen">
          <a class="dropdown-item" *ngFor="let language of languages"
             (click)="changeLanguage(language)"
             [class.selected]="selectedLanguage === language.selectedLanguage"
             [title]="language.languageValue"
             href="javascript:void(0)">
            <span>
              <img class="icon-custom" src="{{language.icon}}" [alt]="language.languageValue">
            </span>
            {{language.languageValue}}
          </a>
        </div>
      </div>
    </div>
    <div class="w-auto">
      <div class="col-sm-auto">
        <div class="date-time text-white">
          <span class="date ">{{currentDate}}, </span>
          <span class="time">{{currentTime}}</span>
        </div>
      </div>
    </div>
  </div>
</div>